import { writable } from 'svelte/store'
import type { Writable } from 'svelte/store'

export const vehicleCategories: Writable<{ id: number; label: string }[]> = writable()
